import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ArrowRightIcon } from '@calendly/ui/components/icons'
import { TitleText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import classNames from 'classnames'

import {
  bannerActionsCss,
  bannerInnerCss,
  bannerInnerPhoneCss,
  bannerMessageCss,
  bannerMessagePhoneCss,
  bannerOuterCss,
  bannerButtonCss,
} from './brandRefreshBetaBannerStyles'

interface BrandRefreshBetaBannerProps {
  daysRemaining: number
  onTryItNow: () => void
}

export const BrandRefreshBetaBanner = ({
  daysRemaining,
  onTryItNow,
}: BrandRefreshBetaBannerProps) => {
  const isPhone = useDeviceType('isPhone')

  return (
    <div
      className={bannerOuterCss}
      data-testid="brand-refresh-beta-banner"
      role="region"
      aria-label={I18n.t('publisher.app_shell.brand_refresh_beta.banner.aria_label')}
    >
      <div className={classNames(bannerInnerCss, { [bannerInnerPhoneCss]: isPhone })}>
        <div className={classNames(bannerMessageCss, { [bannerMessagePhoneCss]: isPhone })}>
          <TitleText size="x-small" level={4}>
            {I18n.t('publisher.app_shell.brand_refresh_beta.banner.body', { count: daysRemaining })}
          </TitleText>
        </div>
        <div className={bannerActionsCss}>
          <Button
            decoration="secondary-outline"
            size="small"
            onClick={onTryItNow}
            data-testid="brand-refresh-try-it-now"
          >
            <span className={bannerButtonCss}>
              {I18n.t('publisher.app_shell.brand_refresh_beta.banner.try_it_now')}
              <ArrowRightIcon inline spacingLeft={4} />
            </span>
          </Button>
        </div>
      </div>
    </div>
  )
}
